<template>
    <div>
        <div class="modal" tabindex="-1" role="dialog" v-if="showModal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $t('edit') }} {{ $t('group_info') }}</h5>
                        <button type="button" class="btn-close" @click="closeModal"></button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="editGroup">
                            <div class="form-group">
                                <label for="user-select" class="form-label">{{ $t('dataheaders.group') }}</label>
                                <select id="user-select" class="form-select" v-model="selectedGroup">
                                    <option value="" disabled selected>{{ $t('select') }} {{ $t('group') }}</option>
                                    <option v-for="group in data" :key="group.user_id" :value="group">
                                        {{ group.group_name }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label for="address" class="form-label">{{ $t('address') }}</label>
                                <input type="text" class="form-control" id="address" v-model="selectedGroup.address"
                                    :disabled="selectedGroup == ''">
                            </div>
                            <div class="form-group">
                                <label for="zip" class="form-label">{{ $t('postalCode') }}</label>
                                <input type="text" class="form-control" id="zip" v-model="selectedGroup.postalCode"
                                    :disabled="selectedGroup == ''">
                            </div>
                            <div class="form-group">
                                <label for="city" class="form-label">{{ $t('city') }}</label>
                                <input type="text" class="form-control" id="city" v-model="selectedGroup.city"
                                    :disabled="selectedGroup == ''">
                            </div>

                            <div v-if="message" :class="alertClass">
                                {{ message }}
                            </div>
                            <div class="modal-footer">
                                <button type="submit" class="btn btn-primary">{{ $t('apply') }}</button>
                                <button type="button" class="btn btn-secondary" @click="closeModal">{{ $t('cancel')
                                    }}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const { getCookie } = require('@/helpers');
import axios from 'axios';

export default {
    data() {
        return {
            selectedGroup: '',
            message: '',
            alertClass: ''
        };
    },
    emits: ['close-modal', 'data-updated'],
    components: {

    },
    watch: {
        selectedGroup: {
            handler: function (newVal) {
                // separate group address into address, postal code and city   
                if (newVal && !newVal.postalCode) {
                    const address = newVal.address.split(',');
                    this.selectedGroup.address = address[0];
                    this.selectedGroup.postalCode = address[1].split(' ')[1];
                    this.selectedGroup.city = address[1].split(' ')[2];
                }
            },
            deep: true
        }
    },
    props: {
        showModal: {
            type: Boolean,
            default: false
        },
        data: {
            type: Array,
            default: () => []
        },
        target: {
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        async editGroup() {
            this.message = ''; // Clear previous message
            // combine address as one string
            this.selectedGroup.address = `${this.selectedGroup.address}, ${this.selectedGroup.postalCode} ${this.selectedGroup.city}`;
            try {
                await axios.post(`${this.$url}/groups`,
                    {
                        ...this.selectedGroup,
                        action: 'update'
                    },
                    {
                        headers: {
                            Authorization: 'Bearer ' + getCookie('token'),
                            ContentType: 'application/json'
                        }
                    });

                // Handle successful response
                this.setMessage(this.$t('success'), true);
                this.$emit('data-updated');
                // Close modal after 3 seconds
                setTimeout(() => {
                    this.closeModal();
                    this.message = ''; // Clear confirmation message
                }, 3000);
            } catch (error) {
                console.error('Error editing user:', error);
                if (error.response && error.response.data) {
                    this.setMessage(this.$t('error') + ': ' + error.response.data, false);
                } else {
                    this.setMessage(this.$t('error') + ': ' + error.message, false);
                }
            }
        },
        closeModal() {
            this.selectedGroup = '';
            this.message = '';
            this.$emit('close-modal');
        },
        setMessage(message, isSuccess) {
            this.message = message;
            this.alertClass = isSuccess ? 'alert alert-success' : 'alert alert-warning';
        }
    }
};
</script>

<style scoped>
.modal {
    display: block;
    /* Ensure modal is displayed */
}
</style>